import axios from "axios";
var jwtDecode = require('jwt-decode')

const API_URL = process.env.REACT_APP_AUTH_PREFIX;

class AuthService {
  login(username, password) {
    var bodyFormData = new FormData();
    bodyFormData.append('username', username);
    bodyFormData.append('password', password);
    return axios({
      method: 'post',
      url: API_URL + "v1_0/auth/token",
      data: bodyFormData,
      headers: {'Content-Type': 'multipart/form-data'}
    }).then(response => {
        if (response.data.access_token) {
          let access_token_decoded = jwtDecode(response.data.access_token);
          response.data.roles = access_token_decoded['roles'];
          response.data.sub = access_token_decoded['sub'];
          response.data.exp = access_token_decoded['exp'];
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout(that=null) {
    localStorage.removeItem("user");
		if (that != null) {
			that.props.history.push("/login")
			window.location.reload();
		}
  }

  register(username, password) {
    return axios.post(API_URL + "v1_0/users/", {
      username,
      password
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }
}

export default new AuthService();
